export default __webpack_public_path__ + "static/FReg-4x3-S_FancyDress-7fd471d205f6a8dc90a2d918bba0deda.jpg";